<template>
  <div v-show="tabledata.length > 0">
    <vuetable ref="vuetable" :fields="tablefields" :api-mode="false" :data="tabledata"
      :css="{ tableClass: 'table table-sm table-hover' }" no-data-template>
      <el-checkbox slot="tick" slot-scope="props" :value="$store.state.modifysid.includes(props.rowData._id)"
        @change="setmodify(props.rowData)"></el-checkbox>

      <span slot="sq" slot-scope="props">{{ props.rowIndex + 1 }}</span>
      <status slot="status" slot-scope="props" :rowData="props.rowData" :rowField="props.rowField"></status>
    </vuetable>
    <div v-if="batchable.length > 0">
      <div v-for="x in batchable" :key="x.name">
        <batchmodifyform :formname="x.name" :thetext="x.label || 'U'"
          :props="{ rowIndex: 0, rowData: tabledata[0], rowField: { disabled: false } }" :rowdata="tabledata[0]">
        </batchmodifyform>
      </div>
    </div>
    <el-button type="danger" @click="clear()">clear exit</el-button>
    <el-button type="primary" @click="addidssearch">Save items</el-button>
  </div>
</template>

<script>
import batchmodifyform from "@/components/utility/commonfields/form/batchmodifyform";
import Vuetable from "vuetable-2";
import VuetableRowHeader from "vuetable-2/src/components/VuetableRowHeader.vue";
import { fieldsprocess } from "zxg-table-fieldsprocess";
import status from "@/components/utility/commonfields/status";


export default {
  components: {
    VuetableRowHeader,
    Vuetable,
    status,
    batchmodifyform
  },
  props: ["collection", "tabletitle"],
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    tablefields() {
      return fieldsprocess(this.$store.state.currentheader, "modifys",this.$store); //extendedfields(this.$store.state.currentheader);
    },
    batchable() {
      let addon = [];
      let fields = fieldsprocess(this.$store.state.currentheader, "table",this.$store);
      fields.forEach((obj) => {
        if (obj.batchable == true) {
          addon.push(obj);
        }
      });
      return addon;
    },
    tabledata() {
      return this.$store.state.modifys;
    },
  },
  methods: {
    addidssearch() {
      this.$prompt('请输入书签名', 'savetag', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputPattern: /.+/,
        inputErrorMessage: 'empty not allowed'
      }).then(({ value }) => {
        this.$store.commit("setsearchmodel", "fetchbyids")
        let query = {
          ids: this.$store.state.modifysid,
          tag: value,
          collection: this.$store.state.collection.value
        }
        this.$axios.generateurl(query)
        this.$store.commit("addsavedsearch", value)

      }).catch(() => { });
    },
    clear() {
      this.$store.commit("resetitems", "modifys");
      this.$store.commit("resetitems", "modifysid");
      this.$router.push("/");
    },
    setmodify(data) {
      this.$store.commit("setmodify", data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/batchmodifys/modifys.vue